import React from 'react';
import {
  CButton, CSpinner,
} from '@coreui/react';

export interface LoadingButtonProps extends CButton {
  isLoading: boolean;
  loadingLabel?: React.ReactNode;
  spinnerProps?: CSpinner;
}

const LoadingButton = (props: LoadingButtonProps) => {
  const {
    isLoading = false,
    loadingLabel,
    children,
    spinnerProps,
    ...buttonProps
  } = props;

  return (
    <CButton
      color="primary"
      className="px-4"
      disabled={isLoading}
      {...buttonProps}
    >
      { isLoading && loadingLabel ? loadingLabel : children }
      { isLoading ? <CSpinner className="ml-2" color="success" size="sm" {...spinnerProps}/> : null }
    </CButton>
  );
};

export default LoadingButton;
